export default "__VITE_ASSET__BpuE0iYG__"